import {
  GET_FINANCE_DRIVERS,
  GET_FINANCE_SINGLE_DRIVER,
  GET_REPORTS_FINANCE_SINGLE_DRIVER,
  GET_SEARCH_FINANCE_DRIVERS,
  DOWNLOAD_FINANCE_DRIVERS,
  DOWNLOAD_SINGLE_FINANCE_DRIVERS
} from "../actions/financeDrivers";
import { POST_DRIVERS_SETTLEMENT } from "../actions/reportsSettlement";

export default function(state = {}, action) {
  switch (action.type) {
    case GET_FINANCE_DRIVERS:
      return { ...state, ...action.payload };
    case GET_FINANCE_SINGLE_DRIVER:
      return { ...state, singleFinanceDriver: action.payload };
    case GET_REPORTS_FINANCE_SINGLE_DRIVER:
      return { ...state, reportsSingleFinanceDriver: action.payload };
    case GET_SEARCH_FINANCE_DRIVERS:
      return { ...state, ...action.payload };
    case DOWNLOAD_SINGLE_FINANCE_DRIVERS:
      return { ...state, reportsSingleFinanceDriver: action.payload };
    case DOWNLOAD_FINANCE_DRIVERS:
      return { ...state, ...action.payload };
    case POST_DRIVERS_SETTLEMENT:
      return {
        ...state,
        singleFinanceDriver: {
          ...state.singleFinanceDriver,
          purse: +state.singleFinanceDriver.purse - +action.payload.data.amount
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/financeDrivers.js